<div mat-subheader class="title"><h3>{{title}}</h3></div>
<div class="list-items">
  <mat-list-item class="items-list" *ngFor="let skill of skills" (click)="updateSkill(skill)" [ngClass]="{ 'selected': skill.selected }">
    <div class="items">
      <div matListItemTitle>{{skill.name}}</div>
      <div class="skillValue ml-1"><sup>({{skill.smeCount || skill.certificateCount}})</sup></div>
    </div>
    <hr>
  </mat-list-item>
</div>
